module.exports = __webpack_public_path__ + "static/media/react-logo.bddb70ec.svg";